<script lang="ts">
  import { ConfirmPopup, TextArea } from '$shared/components';

  interface Props {
    loading?: boolean;
    onevent?: (detail: { type: string; data?: { reason: string } }) => void;
  }

  let { loading = false, onevent }: Props = $props();

  const ConfirmPopupProps = {
    title: 'Cancel CVO Request?',
    desc: 'This will notify our credentialing team to cancel this request.',
    okLabel: 'Yes, Cancel request',
    cancelLabel: 'No, Keep request'
  };

  let reason = $state('');

  const handleEvent = (detail: { type: string }): void => {
    onevent?.({ type: detail.type, data: { reason } });
  };
</script>

<ConfirmPopup {...ConfirmPopupProps} {loading} onevent={handleEvent}>
  <div
    class="textarea-wrapper"
    role="presentation"
    onkeyup={(e) => e.key === 'Enter' && e.stopPropagation()}
  >
    <TextArea
      label="Cancellation Reason:"
      name="cancellation-reason"
      value={reason}
      required={false}
      oninput={(e) => {
        reason = (e.target as HTMLTextAreaElement).value;
      }}
    />
  </div>
</ConfirmPopup>

<style>
  .textarea-wrapper {
    margin-top: 16px;
  }
</style>
